/* eslint-disable import/no-deprecated */
import { Box, Divider, Flex, DeprecatedIcon, Typography } from '@fullstory/components';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export interface AuditLogProps {
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  width?: number;
  objectType?: string;
}

export const AuditLog: React.FC<AuditLogProps> = ({
  createdAt,
  createdBy,
  updatedAt,
  updatedBy,
  width,
  objectType,
}) => {
  const intl = useIntl();
  const defaultType = intl.formatMessage({
    defaultMessage: 'Object',
    id: '8DybGf',
    description: 'generic fallback object type for audit log, object is the default',
  });
  return (
    <Box width={width}>
      <Flex column alignItems="stretch">
        <Box padding={16}>
          <Flex alignItems="center" justifyContent="flex-start">
            <Box marginRight={12}>
              <DeprecatedIcon name="object-changes" color="neutrals-n7" />
            </Box>
            <Typography variant="heading4" color="neutrals-n10">
              <FormattedMessage
                defaultMessage="{objectType} history"
                id="1EkAU6"
                values={{ objectType: objectType ?? defaultType }}
              />
            </Typography>
          </Flex>
        </Box>
        <Divider />
        <Box padding={16}>
          <AuditLogEntry
            title={intl.formatMessage({ defaultMessage: 'Created', id: 'ORGv1Q' })}
            timestamp={createdAt}
            author={createdBy}
          />
          <Box marginTop={16} marginBottom={16}>
            <Divider />
          </Box>
          <AuditLogEntry
            title={intl.formatMessage({ defaultMessage: 'Last updated', id: '0ICwq5' })}
            timestamp={updatedAt}
            author={updatedBy}
          />
        </Box>
      </Flex>
    </Box>
  );
};

interface AuditLogEntryProps {
  title: string;
  timestamp: Date;
  author: string;
}

const AuditLogEntry: React.FC<AuditLogEntryProps> = ({ title, timestamp, author }) => {
  const intl = useIntl();
  return (
    <Box>
      <Typography variant="heading5" color="neutrals-n12">
        {title}
      </Typography>
      <Flex justifyContent="space-between">
        <Box marginRight={8}>
          <Typography variant="body2" color="neutrals-n11">
            {intl.formatDate(timestamp, { dateStyle: 'long' })}
          </Typography>
        </Box>
        <Typography variant="body2" color="neutrals-n11">
          {intl.formatDate(timestamp, { timeStyle: 'short' })}
        </Typography>
      </Flex>
      <Typography variant="body3" color="neutrals-n8">
        {author}
      </Typography>
    </Box>
  );
};
